export const SET_SESSIONID = 'Global/SET_SESSIONID';

export const UPDATE_STEPS = 'Global/UPDATE_STEPS';